(function () {
    "use strict";

    angular.module("app").controller("SecurityIncidentsSearchController", SecurityIncidentsSearchController);

    SecurityIncidentsSearchController.$inject = [
        "$rootScope",
        "controllerDecorator", "infiniteScrollDataSourceFactory", "settingsService", "enumService", "securityIncidentsApi"
    ];
    function SecurityIncidentsSearchController(
        $rootScope,
        controllerDecorator, infiniteScrollDataSourceFactory, settingsService, enumService, securityIncidentsApi
    ) {
        const vm = this;
        controllerDecorator.Decorate(vm, ["navigation", "files", "dialog"]);

        Object.defineProperty(vm, "Filter", { get: () => vm.DataSource.GetFilter() });
        Object.defineProperty(vm, "PageAndSort", { get: () => vm.DataSource.GetPageAndSort() });
        Object.defineProperty(vm, "Items", { get: () => vm.DataSource.Items() });

        vm.open = showDetails;
        vm.canApprove = canApprove;
        vm.approve = approve;
        vm.canReject = canReject;
        vm.reject = reject;
        vm.mapInvolvedPersonsToString = mapInvolvedPersonsToString;
        vm.$onInit = initialize;

        function initialize() {
            vm.DataSource = infiniteScrollDataSourceFactory.Create(securityIncidentsApi.Search, (v) => vm.isLoadingRequests = v);

            if (vm.PageAndSort.SortBy.length > 0) {
                vm.sortType = vm.PageAndSort.SortBy[0].Name;
                vm.sortReverse = vm.PageAndSort.SortBy[0].IsReverse;
            }
            else {
                vm.sortType = "CreatedOn";
                vm.sortReverse = true;
            }

            vm.SetLoadingState(false);
        }

        function showDetails(securityIncident) {
            vm.Dialog.Custom({
                onEscape: true,
                size: "large",
                title: vm.getTranslation("SecurityIncident_Title"),
                templateUrl: getDetailsPageTemplateUrl(securityIncident),
                buttons: {
                    ok: {
                        label: vm.getTranslation("CloseScreen"),
                        className: "btn-primary",
                    }
                }
            });
        }

        function getDetailsPageTemplateUrl(securityIncident) {
            return `${settingsService.applicationPath}security-incidents/details/${securityIncident.PublicId}`;
        }

        function showSuccessMessageAndRefresh(translationKey) {
            vm.ShowSuccess(vm.getTranslation(translationKey));
            vm.DataSource.ResetSearch();
        }

        function mapInvolvedPersonsToString(involvedPersons) {
            return involvedPersons.map(p => `${p.DossierPerson.Name}`).join(", ");
        }

        function canApprove(securityIncident) {
            return securityIncident.Status === enumService.SecurityIncidentStatus.Accepted;
        }

        function approve(securityIncident) {
            const $dialogScope = $rootScope.$new(true);

            $dialogScope.incident = securityIncident;
            $dialogScope.startScreenings = false;
            $dialogScope.involvedPersonsString = securityIncident.InvolvedPersons.map(p => `${p.DossierPerson.Name}`).join(", ");

            vm.Dialog.Custom({
                templateHtml: `
                <div>
                    <div class="row space-below"><p class="alert-info" style="padding: 10px;"><i class="fa fa-info-circle"></i>&nbsp;{{"SecurityIncident_AcceptIncident_InfoMessage_COL" | habilTranslation}}</p></div>
                    <div class="row">
                        <b i18n="SecurityIncident_InvolvedPersons"></b>
                        <p>{{involvedPersonsString}}</p>
                        <fodbz-checkbox fodbz-model="startScreenings"
                                        fodbz-field-const="checkbox-start-screenings"
                                        fodbz-resource="{{'SecurityIncident_StartScreening_s' | habilTranslation}}">
                        </fodbz-checkbox>
                    </div>
                </div>`,
                scope: $dialogScope,
                title: vm.getTranslation("SecurityIncident_AcceptIncident_Title"),
                size: "large",
                onEscape: true,
                closeButton: true,
                buttons: {
                    accept: {
                        label: vm.getTranslation("Shared_Accept"),
                        className: "btn-primary",
                        callback: onSubmit
                    },
                    cancel: {
                        label: vm.getTranslation("Button_Cancel"),
                        className: "btn-default",
                    }
                }
            });

            async function onSubmit() {
                const createScreeningsPromise = $dialogScope.startScreenings ? new Promise(resolve => {
                    securityIncidentsApi.CreateScreenings(securityIncident.PublicId)({}, () => {
                        resolve();
                    });
                }) : Promise.resolve();

                await createScreeningsPromise.then(() => {

                    securityIncidentsApi.AddStatus(securityIncident.PublicId)({ Status: enumService.SecurityIncidentStatus.Accepted }, () => {
                        showSuccessMessageAndRefresh("SecurityIncident_InfoMessage_Accepted");
                    });
                });
            }
        }

        function canReject(securityIncident) {
            return securityIncident.Status === enumService.SecurityIncidentStatus.Accepted;
        }

        async function reject(securityIncident) {
            const reason = await getReasonAsync();

            if (!reason) {
                return;
            }

            securityIncidentsApi.AddStatus(securityIncident.PublicId)({ Status: enumService.SecurityIncidentStatus.Rejected, Description: reason }, () => {
                showSuccessMessageAndRefresh("SecurityIncident_InfoMessage_Rejected");
            });
        }

        function getReasonAsync() {
            return new Promise((resolve) => {
                const dialogOptions = {
                    inputType: "textarea",
                    rows: 5,
                    onEscape: true,
                    size: "large",
                    title: vm.getTranslation("SecurityIncident_RejectIncident_Title"),
                    message: vm.getTranslation("SecurityIncident_RejectReasonPromptMessage"),
                    value: "",
                    required: true,
                    buttons: {
                        confirm: {
                            label: vm.getTranslation("Shared_Reject"),
                            className: "btn-primary",
                        },
                        cancel: {
                            label: vm.getTranslation("Button_Cancel"),
                        },
                    },
                };

                vm.Dialog.Prompt(dialogOptions).then(
                    (reason) => { resolve(reason.trim()); },
                    () => { resolve(null); }
                );
            });
        }
    }
})();
